<template>
  <b-alert show variant="warning" class="text-center">
    <strong>
      Your email needs confirmation
    </strong>
    <p>Please check your email to confirm your address</p>
    <br/>
    <p style="text-decoration:underline">Didn't get an email from us?</p>
    <ul>
      <li>Check your spam folder</li>
      <li>
        Or you can
        <b-button variant="primary" size="sm" @click="resendConfirmation">resend the email</b-button>
        <span v-if="confirmationSent">
          <i class="fas fa-check-circle fa-lg"></i>
        </span>
      </li>
    </ul>
  </b-alert>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('client', {
      confirmationSent: 'confirmationSent'
    })
  },
  methods: {
    ...mapActions({
      resendConfirmation: 'client/resendConfirmation'
    })
  }
}
</script>

<style lang="scss" scoped>
p {
  padding: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/profile/email-needs-confirmation.vue